import React from 'react';

import { Translation } from '../../common';
import { onClickWrapper } from '../../../utils/ui';

const StatisticParameter = ({ styles, onClick, chosen, label, count, id }) => {
  return (
    <div
      onClick={onClickWrapper(id, onClick)}
      className={styles['parameter-statistic']}
    >
      <span className={styles[chosen ? 'parameter-statistic__bold' : null]}>
        <Translation inline>{label}</Translation>
        <span> ({count})</span>
      </span>
    </div>
  );
};

export default StatisticParameter;
